/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const registrationIdRequestDtoTypeEnum = {
  VAT: "VAT",
  EORI: "EORI",
  GLN: "GLN",
  DUNS: "DUNS",
  RCS: "RCS",
  OTHER: "OTHER",
} as const

export type RegistrationIdRequestDtoTypeEnumKey =
  (typeof registrationIdRequestDtoTypeEnum)[keyof typeof registrationIdRequestDtoTypeEnum]

export type RegistrationIdRequestDto = {
  /**
   * @description Registration ID ID
   * @type string | undefined
   */
  id?: string
  /**
   * @description Registration ID
   * @type string
   */
  registrationId: string
  /**
   * @description Registration ID type
   * @type string
   */
  type: RegistrationIdRequestDtoTypeEnumKey
}
